/**
 * @generated SignedSource<<8b02ead29bf022819e14fa08f14f7dd9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MutationsForceUpdateMutation$variables = {
  id: string;
};
export type MutationsForceUpdateMutation$data = {
  readonly forceUpdate: boolean;
};
export type MutationsForceUpdateMutation = {
  response: MutationsForceUpdateMutation$data;
  variables: MutationsForceUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "forceUpdate",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MutationsForceUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MutationsForceUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4161c2b0ea4ea95aa5f1e20b958a2476",
    "id": null,
    "metadata": {},
    "name": "MutationsForceUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation MutationsForceUpdateMutation(\n  $id: ID!\n) {\n  forceUpdate(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "68a18bb938dec1277eb5aa38385cba14";

export default node;
